export const isEmpty = (input) => {
  return input.trim() === '';
};

export const isEmail = (input) => {
  const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

  return input.match(emailRegex);
};
